<template>
  <va-form
    :id="author ? author.id : ''"
    class="create-author__form"
    ref="form"
    :item="author"
    v-model="form"
    :before-save="beforeSave"
    :after-save="afterSave"
    :required-fields-set="requiredFieldsSet">
    <!-- Details -->
    <v-card class="spacing-bottom--24">
      <v-card-title>{{ $t("resources.authors.authors_details_block_title") }}</v-card-title>
      <v-card-subtitle class="spacing-bottom--16">{{
        $t("resources.authors.authors_details_block_subtitle")
      }}</v-card-subtitle>
      <va-text-input
        v-model="form.name"
        source="name"
        required
        :rules="[
          v =>
            !!/^[a-zA-Z_ ]*$/.test(v) ||
            this.$t('generic.validation.special_characters', { field: $t('resources.authors.authors_name') }),
          v => !!v || this.$t('va.forms.required_field', { field: $t('resources.authors.authors_name') }),
        ]"
        class="spacing-bottom--16"
        :label="$t('resources.authors.authors_name')"
        :placeholder="$t('resources.authors.authors_name_placeholder')"></va-text-input>
      <VaImageDragAndDropInput
        :item-id="author ? author.photo : ''"
        :label="$t('resources.authors.author_photo')"
        required
        :display-errors="submitAttempted"
        @update:photo="updateAuthorPhoto"></VaImageDragAndDropInput>
    </v-card>
  </va-form>
</template>

<script>
  // Components
  import VaImageDragAndDropInput from "../custom/VaImageDragAndDropInput";
  // Mixins
  import crudFormMixin from "@/mixins/crudFormMixin";

  export default {
    name: "AuthorForm",
    components: {
      VaImageDragAndDropInput,
    },
    mixins: [crudFormMixin],
    props: {
      author: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        requiredFormFields: ["name", "photo"],
        form: {},
      };
    },
    beforeMount() {
      // Transform some of the form values. (Comes back as object from back-end, but has to be transformed to IRI)
      this.form = this.author ? this.author : {};
      this.form.photo = this.author?.photo?.["@id"];
    },
    methods: {
      updateAuthorPhoto(newValue) {
        if (newValue === "") {
          this.form.photo = null;
        } else {
          this.form.photo = newValue["@id"];
        }
      },
      submit() {
        this.setSubmitAttempted();
        this.$refs.form.onSubmit();
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";
  @import "../../@core/preset/preset/typography/index.scss";

  .author-details-block__photo-disclaimer {
    margin-top: 8px;
    @include text-caption();
    color: get-color("subtitle");
  }
</style>
